import styled from "styled-components";
import { useEffect, useState } from "react";
import {
  Appraiser,
  PracticeActivityAppraiser,
  useLazyGetAppraisersListQuery,
} from "../../redux/apiSpecifications/apiCrud";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { selectAppraiser as testIds } from "../../config/testIds";
import { SelectPair } from "../../types/common.types";

const SelectAppraiserWrapper = styled.div`
  flex: 1;

  .select-appraiser-label {
    // text-transform: uppercase;
    font-size: 0.9em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
`;

const SelectStyled = styled(Select)`
  width: 100%;
  margin-bottom: 2em;
`;

interface ISelectAppraiserProps {
  appraiser: Appraiser | undefined;
  onSelect: (appraiser: Appraiser) => void;
}

const buildAppraiserLabel = ({
  subjectType,
  firstName,
  lastName,
  businessName,
  isInternal,
  practiceCountDaily,
  maxPracticeCountDaily,
}: PracticeActivityAppraiser): string => {
  const name =
    subjectType === "PF"
      ? `${firstName} ${lastName}`
      : subjectType === "PG"
      ? businessName ?? ""
      : "";

  const type = isInternal ? "(I)" : "(E)";
  const workload = `${practiceCountDaily ?? 0}/${maxPracticeCountDaily ?? 0}`;

  return `${name} ${type} ${workload}`;
};

const SelectAppraiser = (props: ISelectAppraiserProps) => {
  const { onSelect } = props;

  const { t } = useTranslation();

  const { selectedTenants, activeRole } = useSelector(
    (state: RootState) => state.user
  );

  const [getApprailsalsList] = useLazyGetAppraisersListQuery();

  const [options, setOptions] = useState<SelectPair[] | undefined>(undefined);

  useEffect(() => {
    (async () => {
      const response = await getApprailsalsList({
        authorization: "",
        activeRole: activeRole!,
        tenantsId: selectedTenants?.map((t) => t.id as number),
      });

      if (response.isSuccess) {
        const appraisersList = response.data as PracticeActivityAppraiser[];

        const _options = appraisersList
          .map((appraiser) => ({
            value: appraiser,
            label: buildAppraiserLabel(appraiser),
          }))
          .slice()
          .sort((a, b) => (a.label > b.label ? 1 : -1));

        setOptions([{ value: { id: 0 }, label: "" }, ..._options]);
      } else {
        setOptions([]);
      }
    })();
  }, [activeRole, selectedTenants]);

  const handleFilterSearchAppraiser = (input: string, option: any) =>
    option.children[0].toLowerCase().indexOf(input.toLowerCase()) > -1;

  const handleSelectAppraiser = (index: string) => {
    const appraiser = options![Number(index)];

    appraiser && onSelect(appraiser.value);
  };

  return (
    <SelectAppraiserWrapper data-testid={testIds.container}>
      <div className="select-appraiser-label">
        {t("search-appraisals-expertizer-label")}
      </div>

      <SelectStyled
        placeholder={t(
          "appraisals-details-tab-activities-select-appraiser-default-message"
        )}
        showSearch
        filterOption={handleFilterSearchAppraiser}
        onChange={(index) => handleSelectAppraiser(index as string)}
        disabled={options === undefined}
      >
        {options?.map((item, i) => (
          <Select.Option key={i}>{item.label} </Select.Option>
        ))}
      </SelectStyled>
    </SelectAppraiserWrapper>
  );
};

export default SelectAppraiser;
